export default "__VITE_ASSET__BjG2Eq6C__"